webpackJsonp([35783957827783],{

/***/ 50:
/***/ (function(module, exports) {

	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}
	
	function LinearEasing (x) {
	  return x;
	}
	
	module.exports = function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  if (mX1 === mY1 && mX2 === mY2) {
	    return LinearEasing;
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  for (var i = 0; i < kSplineTableSize; ++i) {
	    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	  }
	
	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing (x) {
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InviewMonitor = function (_Component) {
	  _inherits(InviewMonitor, _Component);
	
	  function InviewMonitor(props) {
	    _classCallCheck(this, InviewMonitor);
	
	    var _this = _possibleConstructorReturn(this, (InviewMonitor.__proto__ || Object.getPrototypeOf(InviewMonitor)).call(this));
	
	    _this.state = {
	      className: props.classNameNotInView,
	      childProps: props.childPropsNotInView
	    };
	    _this.onIntersectionAll = _this.onIntersectionAll.bind(_this);
	    _this.onIntersection = _this.onIntersection.bind(_this);
	    return _this;
	  }
	
	  _createClass(InviewMonitor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!window.IntersectionObserver) {
	        console.error('react-inview-monitor found no support for IntersectionObserver.\nPerhaps use a polyfill like: https://cdn.polyfill.io/v2/polyfill.js?features=IntersectionObserver ?');
	        return;
	      }
	      var _props = this.props,
	          useInviewMonitor = _props.useInviewMonitor,
	          intoViewMargin = _props.intoViewMargin;
	
	      if (!this._element || !useInviewMonitor || typeof useInviewMonitor === 'function' && !useInviewMonitor()) {
	        return;
	      }
	      var options = {
	        rootMargin: intoViewMargin
	        // any performance benefits from trying to re-use the observer?
	        // possible enhancement to add later on.
	      };this.observer = new window.IntersectionObserver(this.onIntersectionAll, options);
	      this.observer.observe(this._element);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.observer && this.observer.disconnect();
	    }
	  }, {
	    key: 'onIntersectionAll',
	    value: function onIntersectionAll(entries) {
	      entries.forEach(this.onIntersection);
	    }
	  }, {
	    key: 'onIntersection',
	    value: function onIntersection(entry) {
	      if (entry.target !== this._element) {
	        // this check only makes sense as long as we _dont_ share the same observer
	        // between component instances.
	        return;
	      }
	      var _props2 = this.props,
	          classNameNotInView = _props2.classNameNotInView,
	          classNameInView = _props2.classNameInView,
	          classNameAboveView = _props2.classNameAboveView,
	          classNameNotAboveView = _props2.classNameNotAboveView,
	          toggleClassNameOnInView = _props2.toggleClassNameOnInView,
	          childPropsInView = _props2.childPropsInView,
	          childPropsNotInView = _props2.childPropsNotInView,
	          toggleChildPropsOnInView = _props2.toggleChildPropsOnInView,
	          onInView = _props2.onInView,
	          onNotInView = _props2.onNotInView,
	          repeatOnInView = _props2.repeatOnInView;
	
	
	      var nowInView = entry.isIntersecting;
	      var toggleBehavior = (classNameInView || classNameAboveView) && toggleClassNameOnInView || childPropsInView && toggleChildPropsOnInView || (onInView || onNotInView) && repeatOnInView;
	
	      if (nowInView && !toggleBehavior) {
	        this.setState({
	          className: classNameInView,
	          childProps: childPropsInView
	        });
	        if (onInView && typeof onInView === 'function') {
	          onInView(entry);
	        }
	        this.observer.unobserve(entry.target);
	        // is there any point trying to determine whether observer is now
	        // no longer observering anything, and hence should be disconnected,
	        // or is this kind of automatic?
	        // To be investigated.
	        return;
	      }
	
	      if (toggleBehavior) {
	        // Check if we scrolled past view
	        if (classNameAboveView) {
	          if (
	          // we just left the view
	          !nowInView &&
	          // are we now above it (i.e. scrolled past)
	          entry.boundingClientRect.top <= 0) {
	            this.setState({
	              className: classNameAboveView
	            });
	          } else {
	            this.setState({
	              className: classNameNotAboveView || ''
	            });
	          }
	          return;
	        }
	
	        // check regular in/out of view
	        if (nowInView) {
	          // just entered view
	          this.setState({
	            className: classNameInView,
	            childProps: childPropsInView
	          });
	          if (onInView && typeof onInView === 'function') {
	            onInView(entry);
	          }
	        } else {
	          // just left view
	          this.setState({
	            className: classNameNotInView,
	            childProps: childPropsNotInView
	          });
	          if (onNotInView && typeof onNotInView === 'function') {
	            onNotInView(entry);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          childProps = _state.childProps,
	          className = _state.className;
	      var _props3 = this.props,
	          useInviewMonitor = _props3.useInviewMonitor,
	          children = _props3.children;
	
	      if (childProps && Object.keys(childProps).length) {
	        children = _react2.default.cloneElement(children, childProps);
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          ref: function ref(e) {
	            if (e) {
	              _this2._element = e;
	            }
	          }
	        },
	        children
	      );
	    }
	  }]);
	
	  return InviewMonitor;
	}(_react.Component);
	
	InviewMonitor.propTypes = {
	  // common usage: animate classes in onScrollIntoView, to trigger fade in etc animations
	  classNameInView: _propTypes2.default.string,
	  // can be used to hide elements to be animated in.
	  classNameNotInView: _propTypes2.default.string,
	  // can be used as a trigger for "scrolled past view", f.e. for sticky headers
	  classNameAboveView: _propTypes2.default.string,
	  classNameNotAboveView: _propTypes2.default.string,
	  // can be used to switch classes on/off, for fixed navigation based on scroll point, etc
	  toggleClassNameOnInView: _propTypes2.default.bool,
	
	  // another use for the InviewMonitor is to start passing a prop into an element
	  // only when it has been scrolled into view; f.e. to autoplay a video.
	  childPropsInView: _propTypes2.default.object,
	  childPropsNotInView: _propTypes2.default.object,
	  // can be used to turn prop(s) on/off based of on view, f.e. stop/start video/sound
	  toggleChildPropsOnInView: _propTypes2.default.bool,
	
	  // can be used to track elements coming into view
	  onInView: _propTypes2.default.func,
	  onNotInView: _propTypes2.default.func,
	  repeatOnInView: _propTypes2.default.bool,
	
	  // whether to run any scroll monintoring at all;
	  // because easier to toggle this prop, then toggle not using the component at all.
	  useInviewMonitor: _propTypes2.default.func,
	
	  intoViewMargin: _propTypes2.default.string
	};
	InviewMonitor.defaultProps = {
	  classNameNotInView: '',
	  childPropsNotInView: {},
	  useInviewMonitor: function useInviewMonitor() {
	    return true;
	  },
	  intoViewMargin: '-20%'
	};
	
	exports.default = InviewMonitor;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FunShapes = __webpack_require__(49);
	
	var _FunShapes2 = _interopRequireDefault(_FunShapes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Col = __webpack_require__(14);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__(15);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _reactRedux = __webpack_require__(23);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeHero = function (_PureComponent) {
	  _inherits(HomeHero, _PureComponent);
	
	  function HomeHero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomeHero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HomeHero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'home-hero' },
	      _react2.default.createElement(_FunShapes2.default, { strokeColor: '#723239' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container is-position' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'home-hero__title' },
	          'Hello'
	        ),
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-9' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'home-hero__subtitle' },
	              'I\u2019m ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/about' },
	                'Chris Amador'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'home-hero__bio' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'I Make [Cool] Things on The Internet'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'home-hero__welcome text-sm-right' },
	              _react2.default.createElement(
	                'h6',
	                null,
	                'Welcome To My Webfolio V4.0.0'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h6',
	        { className: 'home-hero__speed' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Average 983 ms'
	        ),
	        _react2.default.createElement(_Icon2.default, { id: 'icon-lighting' }),
	        _react2.default.createElement(_Icon2.default, { id: 'icon-lighting' }),
	        _react2.default.createElement(_Icon2.default, { id: 'icon-lighting' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'home-hero__social' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'http://codepen.io/chrisamador/' },
	              _react2.default.createElement(_Icon2.default, { id: 'icon-codepen-logo' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'https://github.com/chrisamador' },
	              _react2.default.createElement(_Icon2.default, { id: 'icon-github' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.linkedin.com/in/chris-amador-b3307288' },
	              _react2.default.createElement(_Icon2.default, { id: 'icon-linkedin' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:chris@chrisamador.me?subject=Website Contact&body=Hi Chris,' },
	              _react2.default.createElement(_Icon2.default, { id: 'icon-contact' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'home-hero__arrow' },
	        _react2.default.createElement(_Icon2.default, { id: 'icon-down-arrow' }),
	        _react2.default.createElement(_Icon2.default, { id: 'icon-down-arrow' }),
	        _react2.default.createElement(_Icon2.default, { id: 'icon-down-arrow' })
	      )
	    );
	  };
	
	  return HomeHero;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    loadTime: 999 //state.siteMeta.loadTime
	  };
	})(HomeHero);
	module.exports = exports['default'];

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _HomeIntroBg = __webpack_require__(236);
	
	var _HomeIntroBg2 = _interopRequireDefault(_HomeIntroBg);
	
	var _reactInviewMonitor = __webpack_require__(494);
	
	var _reactInviewMonitor2 = _interopRequireDefault(_reactInviewMonitor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIntro = function (_PureComponent) {
	  _inherits(HomeIntro, _PureComponent);
	
	  function HomeIntro() {
	    _classCallCheck(this, HomeIntro);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  HomeIntro.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactInviewMonitor2.default,
	      {
	        classNameNotInView: '',
	        classNameInView: 'home-intro-in-view',
	        intoViewMargin: '-5%',
	        toggleClassNameOnInView: true },
	      _react2.default.createElement(
	        'section',
	        { className: 'home-intro' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container is-position' },
	          _react2.default.createElement(
	            'h6',
	            null,
	            'Among the many things I love to do,'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'home-intro__title' },
	            'I Design ',
	            _react2.default.createElement(
	              'span',
	              { className: 'text-group' },
	              '& Code'
	            )
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Websites, Brands, ',
	            _react2.default.createElement(
	              'span',
	              { className: 'text-group' },
	              'Apps, and Prints'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/works', className: 'btn btn-ghost-light' },
	              'View Works'
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'home-intro__or' },
	              'or'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'btn btn-ghost-light' },
	              'Contact Me'
	            )
	          )
	        ),
	        _react2.default.createElement(_HomeIntroBg2.default, null)
	      )
	    );
	  };
	
	  return HomeIntro;
	}(_react.PureComponent);
	
	exports.default = HomeIntro;
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIntroBg = function (_PureComponent) {
	  _inherits(HomeIntroBg, _PureComponent);
	
	  function HomeIntroBg() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomeIntroBg);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HomeIntroBg.prototype.render = function render() {
	    return _react2.default.createElement(
	      'svg',
	      { className: 'home-intro__bg', width: '1832', height: '600', viewBox: '0 0 1832 600' },
	      _react2.default.createElement(
	        'g',
	        { strokeWidth: '2', fill: 'none', fillRule: 'evenodd' },
	        _react2.default.createElement(
	          'g',
	          { className: 'group-light', stroke: '#B7AE9C' },
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1' },
	            _react2.default.createElement('path', { d: 'M.326 101.4L14.46 11.755l5.433.857-14.134 89.643z', transform: 'translate(562 167)'
	            }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M19.35 0l-4.89 11.757 5.433.856z',
	              transform: 'translate(562 167)' }),
	            _react2.default.createElement('path', { d: 'M.326 101.4l-.304 1.926a1.799 1.799 0 0 0 1.497 2.057l1.878.297a1.8 1.8 0 0 0 2.058-1.498l.304-1.926-5.433-.857zM12.512 104.735L33.07 16.344l5.357 1.246-20.558 88.391z',
	              transform: 'translate(562 167)' }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M38.796 4.97l-5.725 11.375 5.357 1.246z',
	              transform: 'translate(562 167)' }),
	            _react2.default.createElement('path', { d: 'M12.512 104.735l-.442 1.9a1.8 1.8 0 0 0 1.345 2.16l1.852.431a1.8 1.8 0 0 0 2.16-1.345l.442-1.9-5.357-1.246z',
	              transform: 'translate(562 167)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1' },
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M.272 32.154L49.367 89.46l49.376-57.307-21.436-29.05-27.94-2.9-27.58 2.9zM1.596 32.542h96.606',
	              transform: 'rotate(10 179.645 4099.664)' }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M21.723 3.166L20.457 32.21 49.368.804 78.456 32.21l-.911-29.044',
	              transform: 'rotate(10 179.645 4099.664)' }),
	            _react2.default.createElement('path', { d: 'M20.627 32.742L49.14 89.47l28.85-56.728', transform: 'rotate(10 179.645 4099.664)'
	            })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1', transform: 'rotate(-10 3192.76 -6222.322)' },
	            _react2.default.createElement('ellipse', { cx: '52.298', cy: '55', rx: '19.36', ry: '50.014', transform: 'rotate(30 52.298 55)'
	            }),
	            _react2.default.createElement('ellipse', { cx: '51.5', cy: '54.203', rx: '19.36', ry: '50.014', transform: 'rotate(-90 51.5 54.203)'
	            }),
	            _react2.default.createElement('ellipse', { cx: '51.899', cy: '54.203', rx: '8.581', ry: '8.565' }),
	            _react2.default.createElement('ellipse', { cx: '52.298', cy: '55', rx: '19.36', ry: '50.014', transform: 'rotate(-30 52.298 55)'
	            })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1' },
	            _react2.default.createElement('path', { d: 'M19.926 74.163L2.443 36.89c-6.04-12.875-.49-28.372 12.334-34.437C27.6-3.612 43.034 1.962 49.074 14.838l17.483 37.271c6.04 12.877.489 28.374-12.334 34.438-12.823 6.064-28.257.491-34.297-12.384z',
	              transform: 'translate(613 339)' }),
	            _react2.default.createElement('path', { d: 'M27.05 22.227a2.405 2.405 0 1 1-4.355 2.05 2.405 2.405 0 0 1 1.152-3.2 2.408 2.408 0 0 1 3.202 1.15z',
	              transform: 'translate(613 339)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { strokeLinecap: 'round', strokeLinejoin: 'round', className: 'group-1' },
	            _react2.default.createElement('path', { d: 'M83 41.5C83 64.42 64.42 83 41.5 83S0 64.42 0 41.5 18.58 0 41.5 0 83 18.58 83 41.5z',
	              transform: 'rotate(-10 1253.582 -7192.447)' }),
	            _react2.default.createElement('path', { d: 'M55.865 41.101c0 8.154-6.61 14.764-14.764 14.764-8.153 0-14.764-6.61-14.764-14.764s6.61-14.764 14.764-14.764 14.764 6.61 14.764 14.764z',
	              transform: 'rotate(-10 1253.582 -7192.447)' }),
	            _react2.default.createElement('path', { d: 'M31.725 57.34c-8.969-5.177-12.042-16.646-6.863-25.615 5.178-8.969 16.646-12.042 25.615-6.863 8.968 5.178 12.042 16.646 6.863 25.615-5.178 8.969-16.646 12.041-25.615 6.864zM24.74 51.077L6.385 19.154M57.462 51.077L39.106 83M40.702 22.346h37.51',
	              transform: 'rotate(-10 1253.582 -7192.447)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1', transform: 'translate(1441 300)' },
	            _react2.default.createElement('circle', { cx: '45', cy: '45', r: '44' }),
	            _react2.default.createElement('path', { d: 'M40.79 23.993c-3.87-3.754-7.27-5.222-9.345-4.21-4.472 2.181-3.154 15.205 3.516 28.882s16.123 22.733 20.594 20.552c4.464-2.177 3.158-15.163-3.484-28.815L40.79 23.992z'
	            }),
	            _react2.default.createElement('path', { d: 'M64.688 52.675c5.208-1.75 8.155-4.208 8.242-6.691.184-5.275-11.916-10.447-27.133-10.979s-27.65 3.785-27.833 9.06c-.086 2.443 2.59 5.054 7.517 7.149l39.207 1.461z'
	            }),
	            _react2.default.createElement('path', { d: 'M59.681 33.04c1.31-5.726.731-9.775-1.435-11.128-4.407-2.754-14.887 5.173-22.954 18.084S24.694 65.8 29.1 68.554c1.957 1.223 5.335.324 9.39-2.634l21.191-32.88z'
	            }),
	            _react2.default.createElement('circle', { cx: '43.5', cy: '43.5', r: '2.5' })
	          ),
	          _react2.default.createElement('path', { d: 'M48.526 13.268c1.286 2.412 4.956.059 4.192-2.32-.761-2.387-6.288-1.686-4.207 2.324l.015-.004zM67.444 68.01c3.89 1.952 4.93-4.224 1.76-4.34-3.166-.112-3.797 3.338-1.764 4.329l.004.01zm20.67-37.582c1.142-13.79-9.203-22.872-17.474-16.627-10.93 8.244-12.066 33.086-27.236 37.47-15.174 4.405-29.342-6.634-27.133-19.162C18.48 19.581 29.309 15.45 32.613 14.99c3.304-.46 8.387.2 9.667-1.213 1.28-1.413 2.355-6.042-8.624-7.146-5.221-.524-17.255 2.647-23.686 11.242-7.096 9.482-7.992 24.936.674 34.054 15.777 16.775 34.1 11.223 41.548 5.661 7.428-5.566 12.263-14.714 18.51-12.363 6.244 2.367-.376 9.534 2.087 11.234C75.277 58.153 87 44.22 88.128 30.427h-.014zM72.291 41.011c-7.004 1 2.967-15.099 5.877-10.16 2.91 4.944-1.79 9.552-5.871 10.173l-.006-.013z',
	            transform: 'translate(358 317)', fillRule: 'nonzero', className: 'group-1' }),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2', transform: 'translate(-100 0)' },
	            _react2.default.createElement('path', { d: 'M1 1h85v75H1z', transform: 'rotate(10 342.584 6548.68)' }),
	            _react2.default.createElement('path', { d: 'M6.587 7.417h73.028v62.167H6.587z', transform: 'rotate(10 342.584 6548.68)'
	            }),
	            _react2.default.createElement('path', { strokeLinecap: 'square', d: 'M23.546 26.87h12.21', transform: 'rotate(10 342.584 6548.68)'
	            }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M10.766 13.196l11.602 4.443v.837l-11.602 4.43',
	              transform: 'rotate(10 342.584 6548.68)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2', transform: 'rotate(-10 2670.873 -7068.45)' },
	            _react2.default.createElement('rect', { width: '72.625', height: '72.625', x: '16.622', y: '16.455', rx: '8', transform: 'rotate(45 52.934 52.768)'
	            }),
	            _react2.default.createElement('path', { d: 'M39.033 15.615l-3.095 3.094 10.55 10.55-.275.625a6.942 6.942 0 0 0-.581 2.793 6.971 6.971 0 0 0 4.182 6.39l.6.262v28.139l-.6.262a6.971 6.971 0 1 0 5.575 0l-.6-.262V39.329l.6-.262.005-.002.626-.274 11.19 11.19-.275.625a6.97 6.97 0 1 0 4.095-3.791l-.592.205L58.98 35.562l.206-.592c.254-.73.385-1.502.385-2.293a6.97 6.97 0 0 0-9.262-6.585l-.593.207-10.683-10.684z'
	            })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2', transform: 'rotate(-20 35.532 9.19)' },
	            _react2.default.createElement('rect', { width: '348', height: '162', x: '1', y: '1', rx: '3.5' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '128.4', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '103.9', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '79.4', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '54.9', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '30.4', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '5.55', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '194.9', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '171.1', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '147.65', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '124.2', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '100.4', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '76.95', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '53.5', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '29.7', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '5.55', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '284.5', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '253.7', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '260.7', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '271.2', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '230.25', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '237.25', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '247.75', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '206.8', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '213.8', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '224.3', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '183', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '190', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '200.5', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '159.55', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '166.55', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '177.05', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '135.75', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '142.75', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '153.25', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '112.3', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '119.3', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '129.8', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '88.85', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '95.85', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '106.35', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '65.05', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '72.05', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '82.55', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '41.6', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '31.25', height: '18.981', x: '5.55', y: '66.39', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '48.6', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '37.9', height: '18.981', x: '5.55', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '37.2', height: '18.981', x: '307.6', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '59.1', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '5.55', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '29.7', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '54.2', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '254.05', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '23.9', height: '21.429', x: '77.65', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '23.9', height: '21.429', x: '224.65', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '113.85', height: '21.429', x: '106.7', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '49.45', height: '18.981', x: '5.55', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '49.45', height: '18.981', x: '295.35', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '278.55', y: '147.866', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '302', y: '147.866', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '302', y: '136.326', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '325.8', y: '147.866', rx: '2.8' })
	          ),
	          _react2.default.createElement('path', { d: 'M26.486 6.804l-15.864 53.33 49.008-8.642L26.485 6.804z', transform: 'translate(281 225)',
	            className: 'group-2' }),
	          _react2.default.createElement('circle', { cx: '31.5', cy: '31.5', r: '30.5', className: 'group-2', transform: 'translate(461 94)'
	          }),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2' },
	            _react2.default.createElement('path', { d: 'M59 93.99l1.6-6.346c1.27.573 2.876 1.014 4.607.563 2.338-.61 3.447-2.484 2.8-4.849l-5.048-18.415L70.404 63l5.07 18.5c1.91 6.97-1.539 11.309-7.858 12.958-2.9.756-5.942.826-8.616-.468zM79.594 87.803l1.533-5.305c1.915.964 5.592 1.456 8.042.8 1.977-.53 2.621-1.396 2.368-2.345-.723-2.715-12.088 3.195-14.318-5.165-.978-3.663 1.31-7.693 7.069-9.237 3.48-.933 6.746-.608 9.417.43l-1.362 5.075c-1.57-.872-4.22-1.316-6.713-.648-1.548.415-2.45 1.35-2.22 2.212.644 2.413 12.09-3.195 14.366 5.338 1.057 3.965-1.644 7.828-7.617 9.43-3.697.99-7.855.767-10.565-.585z',
	              transform: 'translate(1555 157)' }),
	            _react2.default.createElement('path', { d: 'M106.024 51.292L117 92.322 24.687 117 0 24.72 65.946 7.09 92.371 0z',
	              transform: 'translate(1555 157)' })
	          ),
	          _react2.default.createElement('path', { d: 'M1 1h12v12H1zM1 13h12v12H1zM1 25h12v12H1zM13 1h12v12H13zM13 13h12v12H13zM13 25h12v12H13zM25 1h12v12H25zM25 13h12v12H25zM25 25h12v12H25z',
	            transform: 'translate(524 422)', className: 'group-2' }),
	          _react2.default.createElement('path', { d: 'M1 1h54v54H1z', transform: 'rotate(20 -1050.202 1352.4)', className: 'group-2'
	          }),
	          _react2.default.createElement('path', { d: 'M.5 1.5h31.064M.5 8.5h31.064M.5 15.5h31.064', transform: 'translate(578 77)',
	            strokeLinecap: 'round', strokeLinejoin: 'round', className: 'group-2' }),
	          _react2.default.createElement('circle', { cx: '14', cy: '14', r: '13', className: 'group-2', transform: 'translate(217 353)'
	          }),
	          _react2.default.createElement('circle', { cx: '8', cy: '8', r: '7', className: 'group-2', transform: 'translate(1410 461)'
	          }),
	          _react2.default.createElement('path', { d: 'M0 48.703c8.435-4.87 14.446 5.54 22.881.67s2.425-15.28 10.86-20.151c8.436-4.87 14.446 5.54 22.882.67 8.435-4.87 2.425-15.28 10.86-20.15 8.436-4.871 14.446 5.54 22.882.669',
	            transform: 'translate(549 491)', strokeLinecap: 'square', strokeLinejoin: 'round',
	            className: 'group-2' }),
	          _react2.default.createElement('path', { d: 'M330.863 112.27h11.857c5.523 0 10-4.477 10-10V66.737c0-5.523-4.477-10-10-10h-16.531c-5.523 0-10 4.477-10 10v1.767c0 5.523-4.478 10-10 10h-20.377c-5.523 0-10-4.477-10-10V55.687c0-5.522-4.477-10-10-10H167.92c-5.523 0-10 4.478-10 10v23.91c0 5.522-4.478 10-10 10H91.71c-5.523 0-10-4.478-10-10V44.902c0-5.523-4.477-10-10-10H10c-5.523 0-10-4.477-10-10V0',
	            transform: 'translate(733 464)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M58.377 220.727v-56.322c0-5.523-4.477-10-10-10H31.419c-5.522 0-10-4.478-10-10v-37.7c0-5.523-4.477-10-10-10H10c-5.523 0-10-4.478-10-10V26.049c0-5.523 4.477-10 10-10h13.275c5.523 0 10 4.477 10 10v11.614c0 5.523 4.478 10 10 10h16.778c5.523 0 10-4.477 10-10V10c0-5.523 4.477-10 10-10h87.385c5.523 0 10 4.477 10 10v43.774c0 5.523 4.477 10 10 10h86.164c5.523 0 10 4.477 10 10v138.462a10 10 0 0 1-9.587 9.991L68.79 230.719a10 10 0 0 1-10.413-9.991z',
	            transform: 'translate(65 453)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M58.377 220.727v-56.322c0-5.523-4.477-10-10-10H31.419c-5.522 0-10-4.478-10-10v-37.7c0-5.523-4.477-10-10-10H10c-5.523 0-10-4.478-10-10V26.049c0-5.523 4.477-10 10-10h13.275c5.523 0 10 4.477 10 10v11.614c0 5.523 4.478 10 10 10h16.778c5.523 0 10-4.477 10-10V10c0-5.523 4.477-10 10-10h87.385c5.523 0 10 4.477 10 10v43.774c0 5.523 4.477 10 10 10h86.164c5.523 0 10 4.477 10 10v138.462a10 10 0 0 1-9.587 9.991L68.79 230.719a10 10 0 0 1-10.413-9.991z',
	            transform: 'translate(1472 505)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M225.225 10.273v56.323c0 5.523 4.477 10 10 10h16.958c5.522 0 10 4.477 10 10v37.7c0 5.523 4.477 10 10 10h1.419c5.523 0 10 4.477 10 10v60.656c0 5.522-4.477 10-10 10h-13.275c-5.523 0-10-4.478-10-10v-11.615c0-5.523-4.478-10-10-10h-16.778c-5.523 0-10 4.477-10 10V221c0 5.523-4.477 10-10 10h-87.385c-5.523 0-10-4.477-10-10v-43.774c0-5.522-4.477-10-10-10H10c-5.523 0-10-4.477-10-10V18.764a10 10 0 0 1 9.587-9.991L214.812.282a10 10 0 0 1 10.413 9.991z',
	            transform: 'translate(1547 -146)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M0 256.055v-46.612c0-5.523 4.477-10 10-10h38.414c5.523 0 10-4.477 10-10v-35.328c0-5.523-4.477-10-10-10h-17.22a9.247 9.247 0 0 0 0 18.493H77.46c5.523 0 10-4.476 10-10v-38.026c0-5.523 4.477-10 10-10h99.293a9.397 9.397 0 0 0 9.397-9.397 9.397 9.397 0 0 1 9.397-9.397h20.112c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10h-7.113c-5.523 0-10 4.477-10 10v11.645c0 5.522 4.477 10 10 10h94.13',
	            transform: 'translate(1179 142)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M.095 16.17h80.103a8.085 8.085 0 1 0 0-16.17H67.935c-5.523 0-10 4.477-10 10v52.044c0 5.522 4.477 10 10 10h48.884c5.523 0 10 4.477 10 10v.289c0 5.523 4.477 10 10 10H172.5c5.523 0 10 4.477 10 10v67.577',
	            transform: 'translate(312 140)', className: 'group-line' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: 'group-dark', stroke: '#5F594A' },
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1' },
	            _react2.default.createElement('path', { d: 'M.326 101.4L14.46 11.755l5.433.857-14.134 89.643z', transform: 'translate(562 167)'
	            }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M19.35 0l-4.89 11.757 5.433.856z',
	              transform: 'translate(562 167)' }),
	            _react2.default.createElement('path', { d: 'M.326 101.4l-.304 1.926a1.799 1.799 0 0 0 1.497 2.057l1.878.297a1.8 1.8 0 0 0 2.058-1.498l.304-1.926-5.433-.857zM12.512 104.735L33.07 16.344l5.357 1.246-20.558 88.391z',
	              transform: 'translate(562 167)' }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M38.796 4.97l-5.725 11.375 5.357 1.246z',
	              transform: 'translate(562 167)' }),
	            _react2.default.createElement('path', { d: 'M12.512 104.735l-.442 1.9a1.8 1.8 0 0 0 1.345 2.16l1.852.431a1.8 1.8 0 0 0 2.16-1.345l.442-1.9-5.357-1.246z',
	              transform: 'translate(562 167)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1' },
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M.272 32.154L49.367 89.46l49.376-57.307-21.436-29.05-27.94-2.9-27.58 2.9zM1.596 32.542h96.606',
	              transform: 'rotate(10 179.645 4099.664)' }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M21.723 3.166L20.457 32.21 49.368.804 78.456 32.21l-.911-29.044',
	              transform: 'rotate(10 179.645 4099.664)' }),
	            _react2.default.createElement('path', { d: 'M20.627 32.742L49.14 89.47l28.85-56.728', transform: 'rotate(10 179.645 4099.664)'
	            })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1', transform: 'rotate(-10 3192.76 -6222.322)' },
	            _react2.default.createElement('ellipse', { cx: '52.298', cy: '55', rx: '19.36', ry: '50.014', transform: 'rotate(30 52.298 55)'
	            }),
	            _react2.default.createElement('ellipse', { cx: '51.5', cy: '54.203', rx: '19.36', ry: '50.014', transform: 'rotate(-90 51.5 54.203)'
	            }),
	            _react2.default.createElement('ellipse', { cx: '51.899', cy: '54.203', rx: '8.581', ry: '8.565' }),
	            _react2.default.createElement('ellipse', { cx: '52.298', cy: '55', rx: '19.36', ry: '50.014', transform: 'rotate(-30 52.298 55)'
	            })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1' },
	            _react2.default.createElement('path', { d: 'M19.926 74.163L2.443 36.89c-6.04-12.875-.49-28.372 12.334-34.437C27.6-3.612 43.034 1.962 49.074 14.838l17.483 37.271c6.04 12.877.489 28.374-12.334 34.438-12.823 6.064-28.257.491-34.297-12.384z',
	              transform: 'translate(613 339)' }),
	            _react2.default.createElement('path', { d: 'M27.05 22.227a2.405 2.405 0 1 1-4.355 2.05 2.405 2.405 0 0 1 1.152-3.2 2.408 2.408 0 0 1 3.202 1.15z',
	              transform: 'translate(613 339)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { strokeLinecap: 'round', strokeLinejoin: 'round', className: 'group-1' },
	            _react2.default.createElement('path', { d: 'M83 41.5C83 64.42 64.42 83 41.5 83S0 64.42 0 41.5 18.58 0 41.5 0 83 18.58 83 41.5z',
	              transform: 'rotate(-10 1253.582 -7192.447)' }),
	            _react2.default.createElement('path', { d: 'M55.865 41.101c0 8.154-6.61 14.764-14.764 14.764-8.153 0-14.764-6.61-14.764-14.764s6.61-14.764 14.764-14.764 14.764 6.61 14.764 14.764z',
	              transform: 'rotate(-10 1253.582 -7192.447)' }),
	            _react2.default.createElement('path', { d: 'M31.725 57.34c-8.969-5.177-12.042-16.646-6.863-25.615 5.178-8.969 16.646-12.042 25.615-6.863 8.968 5.178 12.042 16.646 6.863 25.615-5.178 8.969-16.646 12.041-25.615 6.864zM24.74 51.077L6.385 19.154M57.462 51.077L39.106 83M40.702 22.346h37.51',
	              transform: 'rotate(-10 1253.582 -7192.447)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-1', transform: 'translate(1441 300)' },
	            _react2.default.createElement('circle', { cx: '45', cy: '45', r: '44' }),
	            _react2.default.createElement('path', { d: 'M40.79 23.993c-3.87-3.754-7.27-5.222-9.345-4.21-4.472 2.181-3.154 15.205 3.516 28.882s16.123 22.733 20.594 20.552c4.464-2.177 3.158-15.163-3.484-28.815L40.79 23.992z'
	            }),
	            _react2.default.createElement('path', { d: 'M64.688 52.675c5.208-1.75 8.155-4.208 8.242-6.691.184-5.275-11.916-10.447-27.133-10.979s-27.65 3.785-27.833 9.06c-.086 2.443 2.59 5.054 7.517 7.149l39.207 1.461z'
	            }),
	            _react2.default.createElement('path', { d: 'M59.681 33.04c1.31-5.726.731-9.775-1.435-11.128-4.407-2.754-14.887 5.173-22.954 18.084S24.694 65.8 29.1 68.554c1.957 1.223 5.335.324 9.39-2.634l21.191-32.88z'
	            }),
	            _react2.default.createElement('circle', { cx: '43.5', cy: '43.5', r: '2.5' })
	          ),
	          _react2.default.createElement('path', { d: 'M48.526 13.268c1.286 2.412 4.956.059 4.192-2.32-.761-2.387-6.288-1.686-4.207 2.324l.015-.004zM67.444 68.01c3.89 1.952 4.93-4.224 1.76-4.34-3.166-.112-3.797 3.338-1.764 4.329l.004.01zm20.67-37.582c1.142-13.79-9.203-22.872-17.474-16.627-10.93 8.244-12.066 33.086-27.236 37.47-15.174 4.405-29.342-6.634-27.133-19.162C18.48 19.581 29.309 15.45 32.613 14.99c3.304-.46 8.387.2 9.667-1.213 1.28-1.413 2.355-6.042-8.624-7.146-5.221-.524-17.255 2.647-23.686 11.242-7.096 9.482-7.992 24.936.674 34.054 15.777 16.775 34.1 11.223 41.548 5.661 7.428-5.566 12.263-14.714 18.51-12.363 6.244 2.367-.376 9.534 2.087 11.234C75.277 58.153 87 44.22 88.128 30.427h-.014zM72.291 41.011c-7.004 1 2.967-15.099 5.877-10.16 2.91 4.944-1.79 9.552-5.871 10.173l-.006-.013z',
	            transform: 'translate(358 317)', fillRule: 'nonzero', className: 'group-1' }),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2', transform: 'translate(-100 0)' },
	            _react2.default.createElement('path', { d: 'M1 1h85v75H1z', transform: 'rotate(10 342.584 6548.68)' }),
	            _react2.default.createElement('path', { d: 'M6.587 7.417h73.028v62.167H6.587z', transform: 'rotate(10 342.584 6548.68)'
	            }),
	            _react2.default.createElement('path', { strokeLinecap: 'square', d: 'M23.546 26.87h12.21', transform: 'rotate(10 342.584 6548.68)'
	            }),
	            _react2.default.createElement('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M10.766 13.196l11.602 4.443v.837l-11.602 4.43',
	              transform: 'rotate(10 342.584 6548.68)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2', transform: 'rotate(-10 2670.873 -7068.45)' },
	            _react2.default.createElement('rect', { width: '72.625', height: '72.625', x: '16.622', y: '16.455', rx: '8', transform: 'rotate(45 52.934 52.768)'
	            }),
	            _react2.default.createElement('path', { d: 'M39.033 15.615l-3.095 3.094 10.55 10.55-.275.625a6.942 6.942 0 0 0-.581 2.793 6.971 6.971 0 0 0 4.182 6.39l.6.262v28.139l-.6.262a6.971 6.971 0 1 0 5.575 0l-.6-.262V39.329l.6-.262.005-.002.626-.274 11.19 11.19-.275.625a6.97 6.97 0 1 0 4.095-3.791l-.592.205L58.98 35.562l.206-.592c.254-.73.385-1.502.385-2.293a6.97 6.97 0 0 0-9.262-6.585l-.593.207-10.683-10.684z'
	            })
	          ),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2', transform: 'rotate(-20 35.532 9.19)' },
	            _react2.default.createElement('rect', { width: '348', height: '162', x: '1', y: '1', rx: '3.5' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '128.4', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '103.9', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '79.4', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '54.9', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '30.4', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '20.4', height: '11.987', x: '5.55', y: '27.925', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '194.9', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '171.1', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '147.65', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '124.2', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '100.4', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '76.95', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '53.5', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '29.7', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '5.55', y: '44.011', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '284.5', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '253.7', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '260.7', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '271.2', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '230.25', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '237.25', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '247.75', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '206.8', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '213.8', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '224.3', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '183', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '190', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '200.5', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '159.55', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '166.55', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '177.05', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '135.75', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '142.75', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '153.25', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '112.3', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '119.3', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '129.8', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '88.85', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '95.85', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '106.35', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '65.05', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '72.05', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '82.55', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '41.6', y: '66.74', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '31.25', height: '18.981', x: '5.55', y: '66.39', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '48.6', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '37.9', height: '18.981', x: '5.55', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '37.2', height: '18.981', x: '307.6', y: '89.819', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '18.981', x: '59.1', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '5.55', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '29.7', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '54.2', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '21.429', x: '254.05', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '23.9', height: '21.429', x: '77.65', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '23.9', height: '21.429', x: '224.65', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '113.85', height: '21.429', x: '106.7', y: '135.977', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '49.45', height: '18.981', x: '5.55', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '49.45', height: '18.981', x: '295.35', y: '112.548', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '278.55', y: '147.866', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '302', y: '147.866', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '302', y: '136.326', rx: '2.8' }),
	            _react2.default.createElement('rect', { width: '19', height: '9.889', x: '325.8', y: '147.866', rx: '2.8' })
	          ),
	          _react2.default.createElement('path', { d: 'M26.486 6.804l-15.864 53.33 49.008-8.642L26.485 6.804z', transform: 'translate(281 225)',
	            className: 'group-2' }),
	          _react2.default.createElement('circle', { cx: '31.5', cy: '31.5', r: '30.5', className: 'group-2', transform: 'translate(461 94)'
	          }),
	          _react2.default.createElement(
	            'g',
	            { className: 'group-2' },
	            _react2.default.createElement('path', { d: 'M59 93.99l1.6-6.346c1.27.573 2.876 1.014 4.607.563 2.338-.61 3.447-2.484 2.8-4.849l-5.048-18.415L70.404 63l5.07 18.5c1.91 6.97-1.539 11.309-7.858 12.958-2.9.756-5.942.826-8.616-.468zM79.594 87.803l1.533-5.305c1.915.964 5.592 1.456 8.042.8 1.977-.53 2.621-1.396 2.368-2.345-.723-2.715-12.088 3.195-14.318-5.165-.978-3.663 1.31-7.693 7.069-9.237 3.48-.933 6.746-.608 9.417.43l-1.362 5.075c-1.57-.872-4.22-1.316-6.713-.648-1.548.415-2.45 1.35-2.22 2.212.644 2.413 12.09-3.195 14.366 5.338 1.057 3.965-1.644 7.828-7.617 9.43-3.697.99-7.855.767-10.565-.585z',
	              transform: 'translate(1555 157)' }),
	            _react2.default.createElement('path', { d: 'M106.024 51.292L117 92.322 24.687 117 0 24.72 65.946 7.09 92.371 0z',
	              transform: 'translate(1555 157)' })
	          ),
	          _react2.default.createElement('path', { d: 'M1 1h12v12H1zM1 13h12v12H1zM1 25h12v12H1zM13 1h12v12H13zM13 13h12v12H13zM13 25h12v12H13zM25 1h12v12H25zM25 13h12v12H25zM25 25h12v12H25z',
	            transform: 'translate(524 422)', className: 'group-2' }),
	          _react2.default.createElement('path', { d: 'M1 1h54v54H1z', transform: 'rotate(20 -1050.202 1352.4)', className: 'group-2'
	          }),
	          _react2.default.createElement('path', { d: 'M.5 1.5h31.064M.5 8.5h31.064M.5 15.5h31.064', transform: 'translate(578 77)',
	            strokeLinecap: 'round', strokeLinejoin: 'round', className: 'group-2' }),
	          _react2.default.createElement('circle', { cx: '14', cy: '14', r: '13', className: 'group-2', transform: 'translate(217 353)'
	          }),
	          _react2.default.createElement('circle', { cx: '8', cy: '8', r: '7', className: 'group-2', transform: 'translate(1410 461)'
	          }),
	          _react2.default.createElement('path', { d: 'M0 48.703c8.435-4.87 14.446 5.54 22.881.67s2.425-15.28 10.86-20.151c8.436-4.87 14.446 5.54 22.882.67 8.435-4.87 2.425-15.28 10.86-20.15 8.436-4.871 14.446 5.54 22.882.669',
	            transform: 'translate(549 491)', strokeLinecap: 'square', strokeLinejoin: 'round',
	            className: 'group-2' }),
	          _react2.default.createElement('path', { d: 'M330.863 112.27h11.857c5.523 0 10-4.477 10-10V66.737c0-5.523-4.477-10-10-10h-16.531c-5.523 0-10 4.477-10 10v1.767c0 5.523-4.478 10-10 10h-20.377c-5.523 0-10-4.477-10-10V55.687c0-5.522-4.477-10-10-10H167.92c-5.523 0-10 4.478-10 10v23.91c0 5.522-4.478 10-10 10H91.71c-5.523 0-10-4.478-10-10V44.902c0-5.523-4.477-10-10-10H10c-5.523 0-10-4.477-10-10V0',
	            transform: 'translate(733 464)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M58.377 220.727v-56.322c0-5.523-4.477-10-10-10H31.419c-5.522 0-10-4.478-10-10v-37.7c0-5.523-4.477-10-10-10H10c-5.523 0-10-4.478-10-10V26.049c0-5.523 4.477-10 10-10h13.275c5.523 0 10 4.477 10 10v11.614c0 5.523 4.478 10 10 10h16.778c5.523 0 10-4.477 10-10V10c0-5.523 4.477-10 10-10h87.385c5.523 0 10 4.477 10 10v43.774c0 5.523 4.477 10 10 10h86.164c5.523 0 10 4.477 10 10v138.462a10 10 0 0 1-9.587 9.991L68.79 230.719a10 10 0 0 1-10.413-9.991z',
	            transform: 'translate(65 453)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M58.377 220.727v-56.322c0-5.523-4.477-10-10-10H31.419c-5.522 0-10-4.478-10-10v-37.7c0-5.523-4.477-10-10-10H10c-5.523 0-10-4.478-10-10V26.049c0-5.523 4.477-10 10-10h13.275c5.523 0 10 4.477 10 10v11.614c0 5.523 4.478 10 10 10h16.778c5.523 0 10-4.477 10-10V10c0-5.523 4.477-10 10-10h87.385c5.523 0 10 4.477 10 10v43.774c0 5.523 4.477 10 10 10h86.164c5.523 0 10 4.477 10 10v138.462a10 10 0 0 1-9.587 9.991L68.79 230.719a10 10 0 0 1-10.413-9.991z',
	            transform: 'translate(1472 505)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M225.225 10.273v56.323c0 5.523 4.477 10 10 10h16.958c5.522 0 10 4.477 10 10v37.7c0 5.523 4.477 10 10 10h1.419c5.523 0 10 4.477 10 10v60.656c0 5.522-4.477 10-10 10h-13.275c-5.523 0-10-4.478-10-10v-11.615c0-5.523-4.478-10-10-10h-16.778c-5.523 0-10 4.477-10 10V221c0 5.523-4.477 10-10 10h-87.385c-5.523 0-10-4.477-10-10v-43.774c0-5.522-4.477-10-10-10H10c-5.523 0-10-4.477-10-10V18.764a10 10 0 0 1 9.587-9.991L214.812.282a10 10 0 0 1 10.413 9.991z',
	            transform: 'translate(1547 -146)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M0 256.055v-46.612c0-5.523 4.477-10 10-10h38.414c5.523 0 10-4.477 10-10v-35.328c0-5.523-4.477-10-10-10h-17.22a9.247 9.247 0 0 0 0 18.493H77.46c5.523 0 10-4.476 10-10v-38.026c0-5.523 4.477-10 10-10h99.293a9.397 9.397 0 0 0 9.397-9.397 9.397 9.397 0 0 1 9.397-9.397h20.112c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10h-7.113c-5.523 0-10 4.477-10 10v11.645c0 5.522 4.477 10 10 10h94.13',
	            transform: 'translate(1179 142)', className: 'group-line' }),
	          _react2.default.createElement('path', { d: 'M.095 16.17h80.103a8.085 8.085 0 1 0 0-16.17H67.935c-5.523 0-10 4.477-10 10v52.044c0 5.522 4.477 10 10 10h48.884c5.523 0 10 4.477 10 10v.289c0 5.523 4.477 10 10 10H172.5c5.523 0 10 4.477 10 10v67.577',
	            transform: 'translate(312 140)', className: 'group-line' })
	        )
	      )
	    );
	  };
	
	  return HomeIntroBg;
	}(_react.PureComponent);
	
	exports.default = HomeIntroBg;
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Col = __webpack_require__(14);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__(15);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DesnotePreview = __webpack_require__(239);
	
	var _DesnotePreview2 = _interopRequireDefault(_DesnotePreview);
	
	var _DesnotePreviewMini = __webpack_require__(85);
	
	var _DesnotePreviewMini2 = _interopRequireDefault(_DesnotePreviewMini);
	
	var _DevlogPreview = __webpack_require__(240);
	
	var _DevlogPreview2 = _interopRequireDefault(_DevlogPreview);
	
	var _DevlogPreviewMini = __webpack_require__(86);
	
	var _DevlogPreviewMini2 = _interopRequireDefault(_DevlogPreviewMini);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import type {DesNotesType} from '../../../types/siteTypes';
	
	var previewType = {
	  logs: _DevlogPreview2.default,
	  notes: _DesnotePreview2.default
	};
	
	var previewMiniType = {
	  logs: _DevlogPreviewMini2.default,
	  notes: _DesnotePreviewMini2.default
	};
	
	var ref = {
	  section_title: {
	    logs: function logs() {
	      return 'Logs';
	    },
	    notes: function notes() {
	      return 'Notes';
	    }
	  },
	  text_intro: {
	    logs: function logs() {
	      return 'Logs (Development Logs) are my thoughts on all things related to the development process. Occasionally I share things about build processes, tooling, javascript, productivity, and anything interesting enough to share.';
	    },
	    notes: function notes() {
	      return 'Notes (Design Notes) are my thoughts on all things related to the design process. Occasionally I share things about trends, tools, design patterns, and anything interesting enough to share.';
	    }
	  }
	};
	
	var d = function d(type) {
	  return function (item) {
	    try {
	      return ref[item][type]();
	    } catch (error) {
	      console.error(error);
	    }
	  };
	};
	
	var HomeLogsNotes = function (_PureComponent) {
	  _inherits(HomeLogsNotes, _PureComponent);
	
	  function HomeLogsNotes() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomeLogsNotes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HomeLogsNotes.prototype.render = function render() {
	    var logsnotes = [].concat(this.props.logsnotes.edges);
	    var type = this.props.type;
	
	    var Preview = previewType[type];
	    var PreviewMini = previewMiniType[type];
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'home-des-notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-12 col-md-4' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-subtitle' },
	              'Latest'
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'text-section-title' },
	              d(type)('section_title')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-intro' },
	              _react2.default.createElement(
	                'p',
	                null,
	                d(type)('text_intro')
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                style: { marginBottom: 40 },
	                to: '/logs-notes?view=' + type,
	                className: 'btn btn-ghost' },
	              'View All'
	            )
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(Preview, { single: logsnotes.shift() })
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(Preview, { single: logsnotes.shift() })
	          )
	        ),
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          logsnotes.map(function (single, index) {
	            return _react2.default.createElement(
	              _Col2.default,
	              { className: 'col-xs-12 col-sm-6 col-md-3', key: index },
	              _react2.default.createElement(PreviewMini, { single: single })
	            );
	          }),
	          logsnotes.length > 0 && _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-6 col-md-3' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/logs-notes?view=' + type, className: 'devdes-more' },
	              _react2.default.createElement(
	                'div',
	                { className: 'devdes-more__text' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'text-subtitle' },
	                  'View All'
	                ),
	                _react2.default.createElement(_Icon2.default, { id: 'icon-right-arrow', className: 'icon-more-arrow' })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return HomeLogsNotes;
	}(_react.PureComponent);
	
	exports.default = HomeLogsNotes;
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _WorkSingle = __webpack_require__(87);
	
	var _WorkSingle2 = _interopRequireDefault(_WorkSingle);
	
	var _index = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeWorks = function (_PureComponent) {
	  _inherits(HomeWorks, _PureComponent);
	
	  function HomeWorks() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomeWorks);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HomeWorks.prototype.render = function render() {
	
	    var works = [].concat(this.props.works.edges),
	        length = this.props.works.totalCount;
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'home-works' },
	      _react2.default.createElement(
	        'header',
	        { className: 'home-works__header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'text-subtitle' },
	            '2011 - 2018'
	          ),
	          _react2.default.createElement(
	            'h4',
	            { className: 'text-section-title' },
	            'Past Works'
	          )
	        )
	      ),
	      this.props.works.edges.map(function (work) {
	        return _react2.default.createElement(_WorkSingle2.default, {
	          key: work.node.fields.slug,
	          work: work,
	          userWorkMeta: {} });
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'home-works__view-all' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/works', className: 'btn btn-primary' },
	          'View All Works (',
	          length,
	          ')'
	        )
	      )
	    );
	  };
	
	  return HomeWorks;
	}(_react.PureComponent);
	
	exports.default = HomeWorks;
	module.exports = exports['default'];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _dateFormater = __webpack_require__(18);
	
	var _dateFormater2 = _interopRequireDefault(_dateFormater);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import type {DesNotesType} from '../../../../types/siteTypes';
	
	var DesNotesPreview = function (_PureComponent) {
	  _inherits(DesNotesPreview, _PureComponent);
	
	  function DesNotesPreview() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DesNotesPreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DesNotesPreview.prototype.render = function render() {
	    var single = this.props.single;
	
	
	    if (!single) ;
	    var formatDate = (0, _dateFormater2.default)(single.node.frontmatter.date);
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: single.node.fields.slug, className: 'desnotes-preview is-color-' + single.node.frontmatter.meta.primary_color,
	        style: { backgroundImage: 'url(' + single.node.frontmatter.images.main_url + ')' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'desnotes-preview__meta' },
	        single.node.frontmatter.tags.map(function (tag) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'h6', key: tag },
	            '#',
	            tag
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'desnotes-preview__title-box' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          single.node.frontmatter.title
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          formatDate
	        )
	      )
	    );
	  };
	
	  return DesNotesPreview;
	}(_react.PureComponent);
	
	exports.default = DesNotesPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _dateFormater = __webpack_require__(18);
	
	var _dateFormater2 = _interopRequireDefault(_dateFormater);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import type {DesNotesType} from '../../../../types/siteTypes';
	
	
	var DesNotesPreviewMini = function (_PureComponent) {
	  _inherits(DesNotesPreviewMini, _PureComponent);
	
	  function DesNotesPreviewMini() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DesNotesPreviewMini);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DesNotesPreviewMini.prototype.render = function render() {
	    var single = this.props.single;
	
	    var formatDate = (0, _dateFormater2.default)(single.node.frontmatter.date);
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: single.node.fields.slug, className: "desnotes-preview-mini is-color-" + single.node.frontmatter.meta.primary_color,
	        style: { backgroundImage: 'url(' + single.node.frontmatter.images.main_url + ')' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'desnotes-preview-mini__title-box' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          single.node.frontmatter.title
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          formatDate
	        )
	      )
	    );
	  };
	
	  return DesNotesPreviewMini;
	}(_react.PureComponent);
	
	exports.default = DesNotesPreviewMini;
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _dateFormater = __webpack_require__(18);
	
	var _dateFormater2 = _interopRequireDefault(_dateFormater);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import type {DevLogType} from "../../../../types/siteTypes";
	
	var DevLogPreview = function (_PureComponent) {
	  _inherits(DevLogPreview, _PureComponent);
	
	  function DevLogPreview() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DevLogPreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DevLogPreview.prototype.render = function render() {
	    var single = this.props.single;
	
	    if (!single) ;
	    var formatDate = (0, _dateFormater2.default)(single.node.frontmatter.date);
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: single.node.fields.slug, className: "devlog-preview is-color-" + single.node.frontmatter.meta.primary_color },
	      _react2.default.createElement(
	        "div",
	        { className: "devlog-preview__inner" },
	        _react2.default.createElement(
	          "div",
	          { className: "devlog-preview__meta" },
	          single.node.frontmatter.tags.map(function (tag) {
	            return _react2.default.createElement(
	              "span",
	              { className: "h6", key: tag },
	              "#",
	              tag
	            );
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "devlog-preview__images" },
	          single.node.frontmatter.images.main_id ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_Icon2.default, { id: single.node.frontmatter.images.type_id, className: "icon-devlog", style: { top: 50, left: -30 } }),
	            _react2.default.createElement(_Icon2.default, { id: single.node.frontmatter.images.main_id, className: "icon-devlog-large", style: { top: 60, right: 10 } })
	          ) : _react2.default.createElement(_Icon2.default, { id: single.node.frontmatter.images.type_id, className: "icon-devlog", style: { top: 50, left: -30 } })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "devlog-preview__title-box" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            single.node.frontmatter.title
	          ),
	          _react2.default.createElement(
	            "h6",
	            null,
	            formatDate
	          )
	        )
	      )
	    );
	  };
	
	  return DevLogPreview;
	}(_react.PureComponent);
	
	exports.default = DevLogPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _dateFormater = __webpack_require__(18);
	
	var _dateFormater2 = _interopRequireDefault(_dateFormater);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DevlogPreviewMini = function (_PureComponent) {
	  _inherits(DevlogPreviewMini, _PureComponent);
	
	  function DevlogPreviewMini() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DevlogPreviewMini);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DevlogPreviewMini.prototype.render = function render() {
	    var single = this.props.single;
	
	    var formatDate = (0, _dateFormater2.default)(single.node.frontmatter.date);
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: single.node.fields.slug, className: "devlog-preview-mini is-color-" + single.node.frontmatter.meta.primary_color },
	      _react2.default.createElement(
	        "div",
	        { className: "devlog-preview-mini__inner" },
	        _react2.default.createElement("div", { className: "devlog-preview-mini__meta" }),
	        _react2.default.createElement(
	          "div",
	          { className: "devlog-preview__images" },
	          _react2.default.createElement(_Icon2.default, { id: single.node.frontmatter.images.type_id, className: "icon-devlog-mini", style: { top: 15, left: "50%", transform: "translateX(-50%)" } })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "devlog-preview-mini__title-box" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            single.node.frontmatter.title
	          ),
	          _react2.default.createElement(
	            "h6",
	            null,
	            formatDate
	          )
	        )
	      )
	    );
	  };
	
	  return DevlogPreviewMini;
	}(_react.PureComponent);
	
	exports.default = DevlogPreviewMini;
	module.exports = exports["default"];

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bezierEasing = __webpack_require__(50);
	
	var _bezierEasing2 = _interopRequireDefault(_bezierEasing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var range = function range(a, b) {
	  return Math.round((b - a) * Math.random() + a);
	};
	var easing = (0, _bezierEasing2.default)(0.5, 0, 1, 0.1);
	
	// Set # of items
	var NUM_SHAPES = 18;
	
	// Draw items base on type tri | cir | arc | rec
	
	var Shape = function () {
	  function Shape(options) {
	    _classCallCheck(this, Shape);
	
	    this.startX = range(0, options.maxWidth - 0);
	    this.startY = range(0, options.maxHeight - 0);
	    this.x = this.startX;
	    this.y = this.startY;
	    this.distanceX = range(50, 300);
	    this.distanceY = range(50, 300);
	    this.speed = 1;
	    this.rotate = range(0, 180);
	    this.rotateSpeed = 0.4; //range(1, 2);
	    this.rotateDir = range(1, 2) === 1 ? -1 : 1;
	    this.scale = 1;
	    this.opacity = 1;
	    this.scaleSpeed = range(1000, 3000);
	    this.startTime = Date.now();
	  }
	
	  Shape.prototype.update = function update(mousePos) {
	    this.rotate = this.rotate > 360 ? 0 : this.rotate + this.rotateSpeed;
	    // if (this.scale < 1) {
	    //   var cal = easing(Math.min((Date.now() - this.startTime) / this.scaleSpeed, 1));
	    //   this.scale = 1 * cal;
	    //   this.opacity = 1 * cal;
	    // }
	    if (!mousePos) return;
	    this.x = this.startX + this.rotateDir * (this.distanceX * easing(mousePos.x));
	    this.y = this.startY + this.rotateDir * (this.distanceY * easing(mousePos.y));
	  };
	
	  return Shape;
	}();
	
	var Rectangle = function (_Shape) {
	  _inherits(Rectangle, _Shape);
	
	  function Rectangle(ctx, options) {
	    _classCallCheck(this, Rectangle);
	
	    var _this = _possibleConstructorReturn(this, _Shape.call(this, options));
	
	    _this.ctx = ctx;
	    _this.length = range(20, 50);
	    return _this;
	  }
	
	  Rectangle.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.rotate(this.rotateDir * (this.rotate * Math.PI / 180));
	
	    this.ctx.beginPath();
	    this.ctx.rect(-(this.length / 2), -(this.length / 2), this.length, this.length);
	    this.ctx.stroke();
	    this.ctx.resetTransform();
	  };
	
	  return Rectangle;
	}(Shape);
	
	var Arc = function (_Shape2) {
	  _inherits(Arc, _Shape2);
	
	  function Arc(ctx, options) {
	    _classCallCheck(this, Arc);
	
	    var _this2 = _possibleConstructorReturn(this, _Shape2.call(this, options));
	
	    _this2.ctx = ctx;
	    _this2.radius = range(20, 50);
	    _this2.sAngle = range(30, 90);
	    return _this2;
	  }
	
	  Arc.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.rotate(this.rotateDir * (this.rotate * Math.PI / 180));
	    this.ctx.beginPath();
	
	    this.ctx.arc(0, 0, this.radius, this.sAngle * Math.PI / 180, 2 * Math.PI);
	    this.ctx.stroke();
	    this.ctx.resetTransform();
	  };
	
	  return Arc;
	}(Shape);
	
	var Circle = function (_Shape3) {
	  _inherits(Circle, _Shape3);
	
	  function Circle(ctx, options) {
	    _classCallCheck(this, Circle);
	
	    var _this3 = _possibleConstructorReturn(this, _Shape3.call(this, options));
	
	    _this3.ctx = ctx;
	    _this3.radius = range(20, 50);
	    _this3.sAngle = range(0, 90);
	    return _this3;
	  }
	
	  Circle.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.beginPath();
	    this.ctx.ellipse(0, 0, this.radius, this.radius, 0, 2 * Math.PI, 0);
	    this.ctx.stroke();
	    this.ctx.closePath();
	
	    this.ctx.resetTransform();
	  };
	
	  return Circle;
	}(Shape);
	
	var Triangle = function (_Shape4) {
	  _inherits(Triangle, _Shape4);
	
	  function Triangle(ctx, options) {
	    _classCallCheck(this, Triangle);
	
	    var _this4 = _possibleConstructorReturn(this, _Shape4.call(this, options));
	
	    _this4.ctx = ctx;
	    _this4.length = range(20, 50);
	    _this4.height = _this4.length * (Math.sqrt(3) / 2);
	    return _this4;
	  }
	
	  Triangle.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.rotate(this.rotateDir * (this.rotate * Math.PI / 180));
	
	    this.ctx.beginPath();
	    this.ctx.moveTo(0, -this.height / 2);
	    this.ctx.lineTo(-this.length / 2, this.height / 2);
	    this.ctx.lineTo(this.length / 2, this.height / 2);
	    this.ctx.lineTo(0, -this.height / 2);
	    this.ctx.stroke();
	    this.ctx.closePath();
	
	    this.ctx.resetTransform();
	  };
	
	  return Triangle;
	}(Shape);
	
	var FunShapes = function (_PureComponent) {
	  _inherits(FunShapes, _PureComponent);
	
	  function FunShapes() {
	    var _temp, _this5, _ret;
	
	    _classCallCheck(this, FunShapes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this5 = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this5), _this5.state = {}, _this5.setCanvasSize = function () {
	      _this5.canvas.width = _this5.canvas.parentElement.parentElement.offsetWidth;
	      _this5.canvas.height = _this5.canvas.parentElement.parentElement.offsetHeight;
	    }, _this5.onMouseMove = function (e) {
	      _this5.mousePos = {
	        x: (e.x / document.documentElement.clientWidth - .5) * 2,
	        y: (e.y / document.documentElement.clientHeight - .5) * 2
	      };
	    }, _this5.createShapes = function () {
	      _this5.ctx = _this5.canvas.getContext("2d");
	
	      _this5.shapes = Array.from({
	        length: NUM_SHAPES
	      }, function () {
	        switch (range(1, 6)) {
	          case 1:
	            return new Rectangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 2:
	            return new Arc(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 3:
	            return new Circle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 4:
	            return new Triangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 5:
	            return new Triangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 6:
	            return new Rectangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	        }
	      });
	    }, _this5.drawShapes = function () {
	      if (_this5.isInView()) {
	        _this5.setCanvasSize();
	        // this.ctx.clearRect(0, 0, (this.canvas ? this.canvas.width : 0), (this.canvas ? this.canvas.height : 0));
	        _this5.ctx.strokeStyle = _this5.props.strokeColor;
	        _this5.ctx.lineWidth = 2;
	        _this5.shapes.map(function (shape) {
	          shape.update(_this5.mousePos);
	          shape.draw();
	        });
	      }
	      if (_this5.shapes.length) {}
	      //this.timeoutID = setTimeout(() => {requestAnimationFrame(this.drawShapes)}, 1000/30);
	    }, _this5.isInView = function () {
	      return _this5.canvas && _this5.canvas.getBoundingClientRect().bottom >= 0;
	    }, _temp), _possibleConstructorReturn(_this5, _ret);
	  }
	
	  FunShapes.prototype.componentDidMount = function componentDidMount() {
	    this.setCanvasSize();
	    // window.addEventListener("resize", this.setCanvasSize)
	    window.addEventListener("mousemove", this.onMouseMove);
	    this.createShapes();
	    this.drawShapes();
	    this.mousePos = {
	      x: 0,
	      y: 0
	    };
	  };
	
	  FunShapes.prototype.componentWillUnmount = function componentWillUnmount() {
	    // window.removeEventListener("resize", this.setCanvasSize)
	    window.removeEventListener("mousemove", this.onMouseMove);
	    this.shapes = [];
	    clearTimeout(this.timeoutID);
	  };
	
	  FunShapes.prototype.render = function render() {
	    var _this6 = this;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "funshapes", style: this.props.style },
	      _react2.default.createElement(
	        "canvas",
	        { ref: function ref(el) {
	            return _this6.canvas = el;
	          } },
	        " "
	      )
	    );
	  };
	
	  return FunShapes;
	}(_react.PureComponent);
	
	exports.default = FunShapes;
	module.exports = exports["default"];

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MockScreen = function (_PureComponent) {
	  _inherits(MockScreen, _PureComponent);
	
	  function MockScreen() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MockScreen);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MockScreen.prototype.render = function render() {
	    var _props = this.props,
	        backgroundImage = _props.backgroundImage,
	        imageSrc = _props.imageSrc;
	
	    var style = {},
	        image = void 0,
	        className = '';
	
	    if (backgroundImage) {
	      style = { backgroundImage: "url(" + backgroundImage + ")" };
	      className = " is-background-image";
	    }
	
	    if (imageSrc && !this.props.children) {
	      image = _react2.default.createElement("img", { className: "img-responsive", src: imageSrc, alt: "" });
	      className = ' is-image';
	    }
	
	    if (this.props.children) {
	      image = _react2.default.createElement(
	        "div",
	        { className: "mock-screen__image" },
	        this.props.children
	      );
	      className = ' is-image';
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "mock-screen" },
	      _react2.default.createElement(
	        "div",
	        { className: "mock-screen__top-bar" },
	        _react2.default.createElement("span", null)
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "mock-screen__screen" + className, style: style },
	        image
	      )
	    );
	  };
	
	  return MockScreen;
	}(_react.PureComponent);
	
	exports.default = MockScreen;
	module.exports = exports["default"];

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	var dateFormater = function dateFormater(date) {
	  // Add 5 hours to match the correct timezone
	  // TODO: fix the timezone issue from YAML http://yaml.org/type/timestamp.html
	  var d = new Date(new Date(date).getTime() + 18000000);
	  return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
	};
	
	exports.default = dateFormater;
	module.exports = exports["default"];

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Col = __webpack_require__(14);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__(15);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _MockScreen = __webpack_require__(33);
	
	var _MockScreen2 = _interopRequireDefault(_MockScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorksSingle = function (_PureComponent) {
	  _inherits(WorksSingle, _PureComponent);
	
	  function WorksSingle() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WorksSingle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  WorksSingle.prototype.render = function render() {
	    var _props = this.props,
	        work = _props.work,
	        userWorkMeta = _props.userWorkMeta;
	
	
	    var read = userWorkMeta ? userWorkMeta.read : false;
	    if (!work) return null;
	    return _react2.default.createElement(
	      'div',
	      { className: 'work-example', style: { backgroundImage: 'url(' + work.node.frontmatter.image_bg.childImageSharp.sizes.originalImg + ')' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'work-example__content' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'work-example__title' },
	                work.node.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'work-example__preview' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  work.node.frontmatter.preview
	                )
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: work.node.fields.slug, className: 'btn btn-white' },
	                'See More'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-7' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: work.node.fields.slug },
	              _react2.default.createElement(_MockScreen2.default, { backgroundImage: work.node.frontmatter.image_preview.childImageSharp.sizes.originalImg })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return WorksSingle;
	}(_react.PureComponent);
	
	var ReadStatus = function ReadStatus(props) {
	  if (props.read) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'badge badge--read' },
	      'Read'
	    );
	  }
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'badge badge--new' },
	      'New!'
	    )
	  );
	};
	
	exports.default = WorksSingle;
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(23);
	
	var _HomeLogsNotes = __webpack_require__(237);
	
	var _HomeLogsNotes2 = _interopRequireDefault(_HomeLogsNotes);
	
	var _HomeHero = __webpack_require__(234);
	
	var _HomeHero2 = _interopRequireDefault(_HomeHero);
	
	var _HomeIntro = __webpack_require__(235);
	
	var _HomeIntro2 = _interopRequireDefault(_HomeIntro);
	
	var _HomeWorks = __webpack_require__(238);
	
	var _HomeWorks2 = _interopRequireDefault(_HomeWorks);
	
	var _siteMeta = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import HomeDesNotes from '../components/home/HomeDesNotes';
	// import HomeDevLogs from '../components/home/HomeDevLogs';
	
	
	var HomePage = function (_PureComponent) {
	  _inherits(HomePage, _PureComponent);
	
	  function HomePage() {
	    _classCallCheck(this, HomePage);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  HomePage.prototype.componentDidMount = function componentDidMount() {
	    this.props.dispatch(_siteMeta.SiteMetaActions.updateSiteMetaColor('white'));
	  };
	
	  HomePage.prototype.render = function render() {
	    // console.log(this.props.data);
	    // let devlogs = [], desnotes = [];
	    var _props$data = this.props.data,
	        logs = _props$data.logs,
	        notes = _props$data.notes,
	        works = _props$data.works;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'home' },
	      _react2.default.createElement(_HomeHero2.default, null),
	      _react2.default.createElement(_HomeIntro2.default, null),
	      _react2.default.createElement(_HomeWorks2.default, { works: works })
	    );
	  };
	
	  return HomePage;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function () {
	  return {};
	})(HomePage);
	
	// Works type
	
	
	// Logs and Notes type
	
	// eslint-disable-next-line
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a4e8414818f7f8f806f9.js